import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=179be6a0&scoped=true"
import script from "./Carts.vue?vue&type=script&lang=js"
export * from "./Carts.vue?vue&type=script&lang=js"
import style0 from "./Carts.vue?vue&type=style&index=0&id=179be6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179be6a0",
  null
  
)

export default component.exports